$(function(){
  init();
  bind();
  goal();

  $(document).on('lazyloaded lazybeforesizes', function(e){
    //sil sagit dimage quon doit utiliser bg cover
    if ($(e.target).hasClass('bg-cover')) {
      //sil sagit dune image qui est aussi offerete en webp
      if ($(e.target).parents('picture').length > 0) {
        $(e.target).parents('picture').backgroundCover();
      }
      //sil sagit tout simplement dun <img>
      else{
        $(e.target).backgroundCover();
      }
    }
  });

  $(".more-filter").on("click",function(){
    if($(this).hasClass("active")){
      $(this).find("span").html("+");
    }
    else{
      $(this).find("span").html("-");
    }
    $(this).toggleClass("active");
    $(".advanced-search").toggleClass("opened");
  });

  $('input').onfocus = function () {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
  }

  $("#search-submit").on("click",function(){
    facebookTag('track', 'ViewContent', {content_type: 'bouton-rechercher'});
  });

  $("a[href^='tel']").on("click",function(){
    googleTag('event', 'prospect_phone', {
      'event_category':'phone',
      'event_action':'click',
      'event_label':'click-phone'
    });
  });

  $(".goal-phone").on("click",function(){
    facebookTag('track', 'Lead', {content_type: 'telephone'});
    gtag_report_conversion();
  });

  if ($('.rangePicker').length > 0) {
    var now = new Date();
    var minDate = moment().add(1, 'days');
    now = now.getTime();

    $('.rangePicker').dateRangePicker({
      minDate: minDate.toDate(),
      startDate: minDate.toDate(),
      minDays: 3,
      selectForward: true,
      showTopbar: false,
      separator: t(' to ', ' au '),
      format: 'D MMM YYYY',
      autoClose: true,
      language: $('html').attr('lang'),
      singleMonth: true,
      stickyMonths: true,
      hoveringTooltip: function(days) {
        //nuités
        days = days - 1;

        var tooltip = days + t(' night', ' nuit') + (days > 1 ? 's' : '');

        return tooltip;
      },
      showShortcuts: true,
      shortcuts : null,
      customShortcuts: [
        {
          'name': t('Clear', 'Effacer'),
          dates : function() {
            $('.rangePicker').data('dateRangePicker').clear();
            return [];
          }
        },
      ],
      beforeShowDay: function(date) {
        if (now > date.getTime()) {
          return [false, '', ''];
        }

        return [true,'',''];
      }
    })
    .bind('datepicker-change', function(event, obj){
      $("#search-from").val(moment(obj.date1).format('YYYY-MM-DD'));
      $("#search-to").val(moment(obj.date2).format('YYYY-MM-DD'));
    });
  }

  if ($('#cottages-sticky-menu .rangePicker').length > 0) {
    $(document).on('scroll.sticky', function(e){
      if ($('.date-picker-wrapper').is(':visible')) {
        $('.rangePicker').data('dateRangePicker').close();
      }
    });
  }

  $(".more-criteria.slim-menu,.advanced-search .close-btn").on("click",function(event){
    $(".more-criteria").toggleClass("active");
    $(".advanced-search").toggleClass("active");
  });

});

function setAC_getUri() {
  var uri = location.pathname;
  if (uri == "/") { uri = "index" }
  uri = uri.replace("/", "")
  return uri;
}

function setAC_cottage(index, item) {
  var uri = setAC_getUri();
  Cookies.set("AC_cottage_position", index, { expires: 7 });
  Cookies.set("AC_cottage_list", uri, { expires: 7 });

  googleTag('event', 'select_content', {
    "content_type": "product",
    "items": [item]
  });
}

function setAC_user(method) {
  Cookies.set("AC_user_method", method, { expires: 7 });
}

function setAC_deleteCart(items, value) {
  googleTag('envet', 'remove_from_cart', {
    'value': value,
    'currency': 'CAD',
    'items': items
  });
  Cookies.remove("AC_cottage_position");
  Cookies.remove("AC_cottage_list");
  Cookies.remove("AC_user_method");
  console.log('cookies removed');
}

$(window).on('load',function() {
  $(".bg-cover").backgroundCover();
});

$(".bg-cover").backgroundCover();

window.onfocus = function () {
  $(".bg-cover").backgroundCover();
};

window.onblur = function () {
  $(".bg-cover").backgroundCover();
};

/*
      _ ____     ____            _    _
     | / ___|   / ___|___   ___ | | _(_) ___  ___
  _  | \___ \  | |   / _ \ / _ \| |/ / |/ _ \/ __|
 | |_| |___) | | |__| (_) | (_) |   <| |  __/\__ \
  \___/|____/   \____\___/ \___/|_|\_\_|\___||___/
==================================================
= Functions to create cookies.                   =
= You can read,create and erase cookies.         =
= Examples :                                     =
= createCookie('popupOpen','cookieOpen',7);      =
==================================================
*/

function createCookie(name,value,days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name,"",-1);
}

function init(){
  bxSliderBasic();
}

function bind(){
  if ($('.bxslider-reg').length > 0){
    $('.bxslider-reg').bxSlider({
      controls: false,
      pager: true,
    });
  }

  $('a.arrow-down[href^="#"]').bind('click.smoothscroll', function(e) {
    e.preventDefault();
    var target = this.hash;
    var windowHeight = $(window).height();
    var position = windowHeight/0.65*1.1;
    $target = $(target);
    $('html, body').stop().animate({
      'scrollTop': (($target.offset().top))
     }, position, function () {
      window.event.preventDefault();
    });
  });

  moment.locale($('html').attr('lang') + '-CA');

  // tipsy
  $('.tooltip').tipsy({
    gravity: 'n',
    fade: true
  });

  $('.mobile-ico').on('click', function(){
    $('#menu-mobile').slideToggle();
  });

  if ($('form.parsley').length){
    $('form.parsley').parsley();
  }

  $('#form-search-button').on('click', function(){
    $('.search-form-toggle').slideToggle();
  });
}

function goal(){
  if ($("#contactformulaire p.alert-success").length > 0) {
    googleTag('event', 'sent', {
      'event_category': 'siteweb',
      'event_label': 'sent-contact-form',
      'value': 1
    });
  }
}

function bxSliderBasic(){
  if ($('.bxslider-basic').length > 0) {
    $('.bxslider-basic').bxSlider({
      controls: true,
      pager: false,
      auto: false,
      speed: 1300,
      pause: 5500,
    });
  }
}


// sticky menu (Nos chalets)
$(document).on("scroll",function(){
    if($(document).scrollTop()>115){
        $("#cottages-sticky-menu").addClass("sticky");
    } else{
        $("#cottages-sticky-menu").removeClass("sticky");
    }
});


$(document).on("scroll",function(){
    if($(document).scrollTop()>850){
        $("#home-sticky-menu").css("display", "block").addClass("sticky");
    } else {
        $("#home-sticky-menu").css("display", "none").removeClass("sticky");
    }

});

function price(n, c) {
  var fr = $('html').attr('lang') == 'fr',
  c = c == undefined ? 2 : c,
  d = fr ? ',' : '.',
  t = ' ',
  s = n < 0 ? "-" : "",
  i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
  j = (j = i.length) > 3 ? j % 3 : 0,
  newp = s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
  newp = fr ? (newp + ' $') : ('$' + newp);

  return newp;
}